import { useMemo } from 'react';

import { useCurrentOrganization } from '@/modules/core/hooks';
import useGetOrgLocksQuery from '@/modules/employer/queries/useGetOrgLocks.query';
import { getIdsFromPath } from '@/utils/modifiers';

const useShowLockBanner = (): boolean => {
  const { observingOrganization } = useCurrentOrganization();
  const currentOrgId = useMemo(() => {
    const { employerId, subsidiaryId } = getIdsFromPath(observingOrganization.path);
    return subsidiaryId || employerId;
  }, [observingOrganization.path]);
  const { formattedData, isError } = useGetOrgLocksQuery(currentOrgId);

  return useMemo(
    () => !isError && !!formattedData?.isLocked && !!formattedData?.hasReplenishedAccounts,
    [formattedData, isError]
  );
};

export default useShowLockBanner;
